<div class="timesheet-container">
  <div class="header">
    <div class="header-title-section">
      <h2>{{ timesheetHeading.TimeSheet }}</h2>
    </div>
    <div class="job-details-search">
      <div class="search-bar-container">
        <div class="search-child">
          <emerald-input
            [label]="'Search'"
            [trailingIcon]="'search'"
            (keyup)="searchTimesheet($event)"
            [value]="filterValue"
            ><emerald-icon
              *ngIf="filterValue?.length && filterValue.length > 0"
              [icon]="'close'"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
        <select
          *ngIf="reporteeData.length > 0"
          class="native-select"
          aria-label="Teams"
          (change)="onReporteesChange($any($event.target).value)"
        >
          <option *ngFor="let o of reporteeData" [value]="o.value" [selected]="selectedEmployee === o.value">{{ o.label }}</option>
        </select>
        <select
          class="native-select"
          aria-label="Month"
          (change)="onMonthSelect($any($event.target).value)"
        >
          <option *ngFor="let opt of monthOptions" [value]="opt.value" [selected]="opt.value === selectedOption">{{ opt.label }}</option>
        </select>
        <div class="select-container">
          <emerald-menu
            [opened]="opened"
            [position]="'bottom_end'"
            [targetElement]="navTemplate"
            [menuTemplate]="menuTemplate"
            (openChange)="opened = $event"
          ></emerald-menu>
          <ng-template #navTemplate>
            <emerald-button
              [label]="'Filter'"
              [size]="'Small'"
              [type]="'Secondary'"
              [icon]="'filter_list'"
              [iconPosition]="'Left'"
              (onClick)="this.opened = !this.opened"
            ></emerald-button>
          </ng-template>
          <ng-template #menuTemplate>
            <app-vendor-management-filter
              [fieldsVisibility]="componentName"
              (filterAppliedTimesheet)="onTimesheetFilterApplied($event)"
              [contractorTimesheet]="rowData"
              [selectedMonth]="selectedmonth"
              [selectedYear]="selectedyear"
              [selectedEmployeeId]="activeEmployeeId"
              [resetTrigger]="filterResetTrigger"
            ></app-vendor-management-filter>
          </ng-template>
        </div>
        <div class="action-buttons">
          <emerald-button
            [label]="'Approve'"
            [type]="'Secondary'"
            [disabled]="isApproveDisabled()"
            (onClick)="reviewTimesheet(TimesheetStatus.Approved)"
          ></emerald-button>
          <emerald-button
            [label]="'Reject'"
            [type]="'Secondary'"
            [disabled]="isSubmitDisabled()"
            (onClick)="reviewTimesheet(TimesheetStatus.Rejected)"
          ></emerald-button>
          <emerald-button
            [label]="'Not Applicable'"
            [type]="'Secondary'"
            [disabled]="isSubmitDisabled()"
            (onClick)="reviewTimesheet(TimesheetStatus.NotApplicable)"
          ></emerald-button>
          <emerald-button
            [label]="'Download'"
            [type]="'Secondary'"
            [icon]="'download'"
            [disabled]="selectedRows.length === 0"
            (onClick)="download()"
          >
          </emerald-button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="displayData?.length; else noDataTemplate">
    <emerald-datatable
      [columnDefs]="columnDefs"
      [rowData]="displayData"
      [paginationParams]="paginationParams"
      (onRowSelect)="onRowSelected($event)"
      [allowResizeColumns]="true"
      [isRowSelectable]="isRowSelectableFunction"
      [forceRefresh]="true"
      [customCellTemplate]="{
        select: customSelectColumn,
        employeeName: customNameColumn,
        action: customActionColumn,
        billableHrs: customBillableHrsColumn,
        workingHrs: customWorkinghrsColumn,
        status: customStatusColumn,
        vendorName: customVendorColumn,
        l3ManagerName: customDntLeaderColumn,
        reportingManager: customReportingMgrColumn,
        location: customLocationColumn,
      }"
    ></emerald-datatable>
  </ng-container>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container>
          <h2 class="empty-state-title">{{ errorMsg }}</h2>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>

  <ng-template #customSelectColumn let-level="level" let-eachRow="eachRow">
    <div *ngIf="shouldShowCheckbox(eachRow); else emptyCell">
      <emerald-checkbox 
        [title]="'Select Item'"
        [checked]="eachRow?.selected || false"
        [forceRefresh]="true"
        (change)="onCheckboxChange(eachRow, $event)">
      </emerald-checkbox>
    </div>
    <ng-template #emptyCell>
      <div class="empty-checkbox-cell"></div>
    </ng-template>
  </ng-template>

  <ng-template #customSortHeader let-level="level">
    <button type="button" class="th-sortbtn" (click)="sortBy(level.field)">
      <span class="th-label">{{ level.headerName }}</span>
      <span class="th-arrow" [class.on]="sortField === level.field">{{
        sortField === level.field && sortDir === 'desc' ? '↓' : '↑'
      }}</span>
    </button>
  </ng-template>

  <ng-template #customVendorColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.vendorName)" (mouseleave)="hideTip()">{{ eachRow?.vendorName }}</span>
  </ng-template>
  <ng-template #customDntLeaderColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.l3ManagerName)" (mouseleave)="hideTip()">{{ eachRow?.l3ManagerName }}</span>
  </ng-template>
  <ng-template #customReportingMgrColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.reportingManager)" (mouseleave)="hideTip()">{{ eachRow?.reportingManager }}</span>
  </ng-template>
  <ng-template #customLocationColumn let-eachRow="eachRow">
    <span class="ts-ellipsis" (mouseenter)="showTip($event, eachRow?.location)" (mouseleave)="hideTip()">{{ eachRow?.location }}</span>
  </ng-template>

  <ng-template #customNameColumn let-level="level" let-eachRow="eachRow">
    <div class="member">
      <div class="name">
        <a (click)="navigateToContractorProfile(eachRow?.employeeId)">{{
          eachRow?.employeeName
        }}</a>
      </div>
      <div class="title">
        <span class="emp-id">{{ eachRow?.employeeId }}</span><span *ngIf="eachRow?.jobTitle"> · {{ eachRow?.jobTitle }}</span>
      </div>
    </div>
  </ng-template>
  <ng-template #customActionColumn let-level="level" let-eachRow="eachRow">
    <div class="action">
      <div class="notify-icon-container" title="Calendar">
        <emerald-icon
          [icon]="'date_range'"
          (click)="opened = true"
          [fontsizeInRem]="iconFontSize"
          (click)="openTimesheetCalendar(eachRow)"
        >
        </emerald-icon>
      </div>
    </div>
  </ng-template>
  <ng-template #customBillableHrsColumn let-level="level" let-eachRow="eachRow">
    <span>
      {{ eachRow?.billableHrs }}{{ getHoursSuffix() || '' }}
    </span>
  </ng-template>
  <ng-template #customWorkinghrsColumn let-level="level" let-eachRow="eachRow">
    {{ eachRow?.workingHrs }}{{ getHoursSuffix() || '' }}
  </ng-template>
  <ng-template #customStatusColumn let-level="level" let-eachRow="eachRow">
    <div class="status-container">
      <span
        class="ts-pill"
        [ngClass]="{
          'ok': eachRow?.status === TimesheetStatus.Approved,
          'crit': eachRow?.status === TimesheetStatus.Rejected,
          'warn': eachRow?.status === TimesheetStatus.PendingApproval || (eachRow?.status == null && !(eachRow?.workingHrs === 0 && eachRow?.billableHrs === 0)),
          'cold': eachRow?.status === TimesheetStatus.NotApplicable || (eachRow?.status == null && eachRow?.workingHrs === 0 && eachRow?.billableHrs === 0)
        }"
      >
        <span class="dot"></span>
        <ng-container *ngIf="eachRow?.status; else pendingStatus">
          {{eachRow?.status}}
        </ng-container>
        <ng-template #pendingStatus>
          <ng-container
            *ngIf="
              eachRow?.workingHrs === 0 && eachRow?.billableHrs === 0;
              else pendingApproval
            "
          >
            {{ TimesheetStatus.PendingSubmission }}
          </ng-container>
          <ng-template #pendingApproval>
            {{ TimesheetStatus.PendingApproval }}
          </ng-template>
        </ng-template>
      </span>
    </div>
  </ng-template>
  <div *ngIf="isTimesheetCalendarOpen" class="modal-container">
    <div class="dim-background" (click)="closeTimesheetCalendar()"></div>
    <div class="modal-content">
      <app-timesheet-calendar
        *ngIf="isTimesheetCalendarOpen"
        [componentName]="componentName"
        [candidateDetails]="selectedRowData"
        [selectedyear]="selectedyear"
        [selectedmonth]="selectedmonth"
        (closeComponent)="closeTimesheetCalendar()"
      ></app-timesheet-calendar>
    </div>
  </div>
  <app-modal-wrapper
    *ngIf="showContractorProfile"
    [showModal]="showContractorProfile"
  >
    <app-contractor-profile
      [contractorId]="selectedContractorId"
      (close)="showContractorProfile = false;"
      [navigationSourceTeam]="'timesheet'"
    ></app-contractor-profile>
  </app-modal-wrapper>
  <app-confirmation-dialog
    [isOpen]="showReviewConfirmation"
    [title]="reviewConfirmationTitle"
    [message]="reviewConfirmationMessage"
    [submitLabel]="reviewConfirmationSubmitLabel"
    [cancelLabel]="'Cancel'"
    (confirm)="onConfirmReview()"
    (cancel)="onCancelReview()">
  </app-confirmation-dialog>

  <div class="ts-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
    {{ hoverTip.text }}
  </div>
</div>
